import {
  getCollectionList,
  getClientsTemplate,
  getClientServiceTemplate,
  createCollectionTrigger,
  getCollectionTriggers,
  getCollectionScenarios,
  createCollectionScenerios,
  getCollectionActions,
  deleteCollectionTrigger,
  deleteCollectionScenario,
  editCollectionTrigger,
  editCollectionScenario,
  deleteCollection,
  getCollectionById,
  editCollection,
  createCollectionTemplate
} from "@/http/setup/collectionProfile.js";

export default {
  namespaced: true,
  state: {
    collections: [],
    categoryTemplate: [],
    createTemplate: [],
    serviceTemplate: {},
    collectionTriggers: [],
    collectionScenerios: [],
    collectionActions: [],
    collection: {},
  },
  actions: {
    async fetchCollectionList({ commit }) {
      try {
        const res = await getCollectionList();
        commit("SET_COLLECTION_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCollectionById({ commit }, id) {
      try {
        const res = await getCollectionById(id);
        commit("SET_COLLECTION", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCollectionTemplateList({ commit }) {
      try {
        const res = await getClientsTemplate();
        commit("SET_COLLECTION_TEMPLETE_LIST", res.data.createTemplate);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCollectionTemplateService({ commit }) {
      try {
        const res = await getClientServiceTemplate();
        commit("SET_COLLECTION_TEMPLETE_SERVICE", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createCollectionTriggerAction({ commit }, data) {
      try {
        const res = await createCollectionTrigger(data);

        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editCollectionAction({ commit }, data) {
      try {
        const res = await editCollection(data);

        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCollectionTriggersAction({ commit }, id) {
      try {
        const res = await getCollectionTriggers(id);
        commit("SET_COLLECTION_TRIGGERS", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createCollectionSceneriosAction({ commit }, data) {
      try {
        const res = await createCollectionScenerios(data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCollectionScenariosAction({ commit }, id) {
      try {
        const res = await getCollectionScenarios(id);
        commit("SET_COLLECTION_SCANARIOS", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchCollectionActions({ commit }) {
      try {
        const res = await getCollectionActions();
        commit("SET_COLLECTION_ACTIONS", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteCollectionTriggerAction({ commit }, id) {
      try {
        const res = await deleteCollectionTrigger(id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteCollectionAction({ commit }, id) {
      try {
        const res = await deleteCollection(id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteCollectionScenarioAction({ commit }, id) {
      try {
        const res = await deleteCollectionScenario(id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editCollectionScenarioAction({ commit }, data) {
      try {
        const res = await editCollectionScenario(data);

        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editCollectionTriggerAction({ commit }, data) {
      try {
        const res = await editCollectionTrigger(data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createCollectionTemplateList(_, data) {
      try {
        const res = await createCollectionTemplate(data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_COLLECTION_TEMPLETE_LIST(state, payload) {
      state.createTemplate = payload;
    },
    SET_COLLECTION_LIST(state, payload) {
      state.collections = payload;
    },
    SET_COLLECTION(state, payload) {
      state.collection = payload;
    },
    SET_COLLECTION_TEMPLETE_SERVICE(state, payload) {
      state.serviceTemplate = payload;
    },
    SET_COLLECTION_TRIGGERS(state, payload) {
      state.collectionTriggers = payload;
    },
    SET_COLLECTION_SCANARIOS(state, payload) {
      state.collectionScenerios = payload;
    },
    SET_COLLECTION_ACTIONS(state, payload) {
      state.collectionActions = payload;
    },
  },
};
